
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { PlusCircle, Edit } from 'lucide-react';
import { Lesson } from '@/data/lessons';

interface LessonListProps {
  lessons: Lesson[];
  currentLessonDay: number;
  onSelectLesson: (lesson: Lesson) => void;
  onCreateLesson: () => void;
}

const LessonList: React.FC<LessonListProps> = ({
  lessons,
  currentLessonDay,
  onSelectLesson,
  onCreateLesson
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredLessons = lessons.filter(lesson => 
    lesson.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    lesson.subtitle.toLowerCase().includes(searchTerm.toLowerCase()) ||
    lesson.day.toString().includes(searchTerm)
  );

  return (
    <div className="w-full space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">Lessons</h2>
        <Button 
          variant="outline" 
          size="sm"
          onClick={onCreateLesson}
        >
          <PlusCircle className="mr-1 h-4 w-4" />
          New
        </Button>
      </div>
      
      <Input
        placeholder="Search lessons..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="mb-4"
      />
      
      <div className="space-y-2 max-h-[500px] overflow-y-auto pr-2">
        {filteredLessons.map((lesson) => (
          <div 
            key={lesson.day}
            className={`p-3 rounded-lg border cursor-pointer ${
              currentLessonDay === lesson.day 
                ? 'border-hormony-coral bg-hormony-light-coral/10' 
                : 'border-hormony-beige hover:bg-hormony-beige/10'
            }`}
            onClick={() => onSelectLesson(lesson)}
          >
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium">Day {lesson.day}</span>
              <Edit className="h-3.5 w-3.5 text-hormony-charcoal/60" />
            </div>
            <h3 className="text-sm font-medium truncate">{lesson.title}</h3>
            <p className="text-xs text-hormony-charcoal/60 truncate">{lesson.subtitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LessonList;
